module.exports = __webpack_public_path__ + "img/sri_bus.85a26d01.png";